import { z } from 'zod';
;
const searchAgentHistoryResponseSchema = z.object({
    results: z.array(z.object({
        id: z.union([z.string(), z.number()]),
        name: z.string(),
    })),
});
export class AgentResourcesClient {
    constructor(authenticatedClient) {
        this.authenticatedClient = authenticatedClient;
        this.getAgentResources = async (data) => {
            const response = await this.authenticatedClient.get(`/chat/agents/${data.agentIdentifier}/resources`);
            return response.data;
        };
        this.searchAgentFilter = async (data) => {
            const response = await this.authenticatedClient.get(`/chat/agents/${data.agentIdentifier}/filter-search/${data.filterId}?query=${data.query ?? ''}`);
            return searchAgentHistoryResponseSchema.parse(response.data);
        };
    }
}
